import useSWR from 'swr';
import { api, apiFetch, getUserToken } from '@utils/api';

/**
 * Hook to fetch banner ads
 * @returns {object} { banners, isLoading, error }
 */
export const useBanners = () => {
    const { data, error, isLoading } = useSWR(
        api('/api/banners'),
        async (url) => {
            try {
                const response = await fetch(url);
                const result = await response.json();

                if (result.success && result.banners) {
                    return result.banners;
                }

                // Fallback to default banners
                return {
                    mobile: {
                        imageUrl: 'https://imagizer.imageshack.com/img924/2028/rCwzXh.gif',
                        targetUrl: '#'
                    },
                    desktop: {
                        imageUrl: 'https://imagizer.imageshack.com/img923/9748/8t6nNE.gif',
                        targetUrl: '#'
                    }
                };
            } catch (err) {
                // Return fallback on error
                return {
                    mobile: {
                        imageUrl: 'https://imagizer.imageshack.com/img924/2028/rCwzXh.gif',
                        targetUrl: '#'
                    },
                    desktop: {
                        imageUrl: 'https://imagizer.imageshack.com/img923/9748/8t6nNE.gif',
                        targetUrl: '#'
                    }
                };
            }
        },
        {
            revalidateOnFocus: false,
            dedupingInterval: 600000, // 10 minutes
            fallbackData: {
                mobile: {
                    imageUrl: 'https://imagizer.imageshack.com/img924/2028/rCwzXh.gif',
                    targetUrl: '#'
                },
                desktop: {
                    imageUrl: 'https://imagizer.imageshack.com/img923/9748/8t6nNE.gif',
                    targetUrl: '#'
                }
            }
        }
    );

    return {
        banners: data || {},
        isLoading,
        error,
    };
};

export default useBanners;
